module.exports = __webpack_public_path__ + "img/angles-down.cfe12d0f.svg";